<template>
  <modal
    :title="
      pricePackage.repaymentPlanPackageNumber
        ? 'Edit Package'
        : 'Add New Package'
    "
    ref="modifyPackageModal"
    @save="savePackage()"
  >
    <div class="row">
      <div class="form-group col-md-10">
        <label class="control-label"> Description </label>
        <input
          type="text"
          class="form-control"
          v-model="pricePackage.label"
        />
      </div>
    </div>
    <div class="row">
      <div
        class="form-group col-md-10"
        v-if="pricePackage.repaymentPlanPackageNumber"
      >
        <label class="control-label"> Expired </label>
        <v-select :options="['true', 'false']" v-model="expired"></v-select>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-10">
        <label class="control-label"> Terms </label>
        <v-select
          placeholder="Select Package Terms"
          :options="[
            { name: 'TWELVE_MONTHS', description: '12 Months' },
            { name: 'SIX_MONTHS', description: '6 Months' },
          ]"
          valueProp="name"
          label="description"
          v-model="pricePackage.terms"
        ></v-select>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/GeneralComponents/Modal";
export default {
  props: {
    pricePackage: {
      type: Object,
      required: true,
    },
  },
  computed: {
    expired: {
      get() {
        return this.pricePackage.expired.toString();
      },
      set(expired) {
        this.pricePackage.expired = expired;
      },
    },
  },
  components: {
    Modal,
  },
  methods: {
    open() {
      this.$refs.modifyPackageModal.open();
    },
    savePackage() {
      this.$refs.modifyPackageModal.isLoading();
      this.$http
        .post(
          this.$config.aimsAPI + "pricing/repaymentplanpackages/save",
          this.pricePackage
        )
        .then(
          (response) => {
            this.$refs.modifyPackageModal.close();
            if (this.pricePackage.repaymentPlanPackageNumber) {
              this.showSuccess("Successfully Edited Package");
              this.$emit("packageEdited");
            } else {
              this.showSuccess("Successfully Created Package");
              this.$emit("packageAdded", response.data);
            }
          },
          (error) => {
            this.showError("Error Saving Pricing", error);
            console.error(error);
          }
        )
        .finally(() => {
          this.$refs.modifyPackageModal.isLoading();
        });
    },
  },
};
</script>

<style>
</style>
